import { ActionContext } from "vuex";
import * as fb from "../../firebase";
import {
  collection,
  query,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";

import {
  ADD_USER_WITHDRAWAL,
  Withdrawal,
  DELETE_USER_WITHDRAWAL,
  SetListenerRequest,
  SET_LISTENER,
  UPDATE_USER_WITHDRAWAL,
  WithdrawalsState,
} from "./WithdrawalsInterfaces";

const initialState: WithdrawalsState = {
  withdrawals: [],
};
const snapshotListeners = {
  withdrawals: () => {
    return;
  },
};

const state: WithdrawalsState = { ...initialState };

const mutations = {
  ADD_USER_WITHDRAWAL(state: WithdrawalsState, withdrawal: Withdrawal) {
    state.withdrawals.push(withdrawal);
  },
  DELETE_USER_WITHDRAWAL(state: WithdrawalsState, withdrawalId: number) {
    state.withdrawals = state.withdrawals.filter((item) => {
      return item._id != withdrawalId;
    });
  },
  UPDATE_USER_WITHDRAWAL(state: WithdrawalsState, withdrawal: Withdrawal) {
    const index = state.withdrawals.findIndex((item: any) => {
      return item._id == withdrawal._id;
    });
    state.withdrawals[index] = withdrawal;
  },
  CLEAR_USER_WITHDRAWALS(state: WithdrawalsState) {
    if (state) {
      state.withdrawals = [];
    }
  },
  SET_LISTENER(state: WithdrawalsState, request: SetListenerRequest) {
    snapshotListeners.withdrawals = request.listener;
  },
  CLEAR_LISTENER() {
    snapshotListeners.withdrawals();
  },
};

const actions = {
  doGetWithdrawals(context: ActionContext<WithdrawalsState, any>) {
    const username = context.rootState.auth.userProfileData._usernamePK;
    const _userWithdrawals = query(
      collection(fb.firestore, "users", username, "userWithdrawals"),
      orderBy("_id", "desc"),
      limit(100)
    );

    const l = onSnapshot(_userWithdrawals, (querySnapshot) => {
      querySnapshot.docChanges().forEach((change) => {
        const doc = change.doc;
        if (doc.data()) {
          const withdrawal = doc.data() as Withdrawal;
          if (change.type == "added") {
            context.commit(ADD_USER_WITHDRAWAL, withdrawal);
          } else if (change.type == "modified") {
            context.commit(UPDATE_USER_WITHDRAWAL, withdrawal);
          }
        } else if (change.type == "removed") {
          context.commit(DELETE_USER_WITHDRAWAL, doc.id);
        }
      });
    });

    context.commit(SET_LISTENER, { listenerId: "withdrawals", listener: l });
  },
  unsubscribeListener() {
    snapshotListeners.withdrawals();
  },
};
const getters = {
  getWithdrawals(state: WithdrawalsState): Array<Withdrawal> {
    return state ? state.withdrawals : new Array<Withdrawal>();
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
